import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import ResourceRepository from "../Repository/ResourceRepository";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import DocumentRepository from "../Repository/DocumentRepository";
import DocumentDownload from "../Entity/DocumentDownload";
import DocumentResource from "../Entity/DocumentResource";

export default class RemoveCompleteDownload {
    public constructor(
        private readonly documentRepository: DocumentRepository,
        private readonly downloadManagerRepository: DownloadManagerRepository,
        private readonly resourceRepository: ResourceRepository,
        private readonly documentResourceRepository: DocumentResourceRepository
    ) {
    }

    public remove(document: DocumentDownload): void {
        this.documentResourceRepository.remove(document.getResourceIdWithId());
        this.documentRepository.remove(document.getIdString());
        if (this.hasDocumentResources(document)) {
            return;
        }

        this.downloadManagerRepository.remove(document.getResourceId());
        this.resourceRepository.remove(document.getResourceId());
    }

    public hasDocumentResources(document: DocumentDownload): boolean {
        const documentResources: DocumentResource[] = this.documentResourceRepository.getAllByResourceId(document.getResourceId());
        return documentResources.length > 0;
    }
}